import React from 'react';
import PropTypes from 'prop-types';

import { Label, Input, StyledRadioButton } from './style';

const RadioButton = ({
  label,
  name,
  value,
  onChange,
  checked,
  disabled,
  className,
}) => {
  const handleOnChange = (e) => {
    const { currentTarget } = e;
    if (onChange) onChange(currentTarget.value);
  };
  return (
    <StyledRadioButton className={className} disabled={disabled}>
      <Input
        className={checked ? 'checked' : ''}
        type="radio"
        name={name}
        value={value}
        onChange={handleOnChange}
        disabled={disabled}
      />
      <Label>{label}</Label>
    </StyledRadioButton>
  );
};

RadioButton.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default RadioButton;
